/* custom-product-title.js — GOAT Fitness specific product titles
 *
 * Consolidating each line into one variant product means the page heading is the
 * line name, not the thing being looked at. Picking 25 lbs on Rubber Hex
 * Dumbbells still reads "Rubber Hex Dumbbells", and every bundle under it reads
 * the same. This appends the selected variant — or the selected bundle — to the
 * heading, so the page always names what is actually on screen.
 *
 * Owns the heading exclusively. custom-bundle-swap.js does not write to it; it
 * fires goat:title-override / goat:title-release and this decides. Two scripts
 * writing the same element is how you get a title that flickers between them.
 *
 * Dawn re-renders parts of the product info container on variant change, and
 * which parts depends on the theme version. Rather than guess, a MutationObserver
 * re-applies the heading whenever it gets overwritten. The write is guarded on
 * the text actually differing, so it cannot feed itself.
 */
(function () {
  'use strict';

  var SEP = ' — ';
  var base = null;      // product title as rendered server-side
  var override = null;  // bundle title, when a bundle is selected
  var desired = null;
  var writing = false;

  function heads() {
    // Dawn prints the title twice: an h1 and a linked h2 used at narrow widths.
    // Updating only the h1 leaves the other one stale on mobile.
    return document.querySelectorAll('.product__title h1, .product__title h2');
  }

  function variantSuffix() {
    var vs = document.querySelector('variant-selects');
    if (!vs) return '';
    var parts = [];
    // Walk the picker in document order so a multi-option product reads in the
    // same order Shopify names its variants.
    var nodes = vs.querySelectorAll('input[type="radio"], select');
    for (var i = 0; i < nodes.length; i++) {
      var n = nodes[i];
      if (n.tagName === 'SELECT') {
        if (n.value) parts.push(n.value.trim());
      } else if (n.checked && n.value) {
        parts.push(n.value.trim());
      }
    }
    // Dawn names a single-variant product's option "Default Title"; appending it
    // would put that string in front of a customer.
    parts = parts.filter(function (p) { return p && p !== 'Default Title'; });
    return parts.join(' / ');
  }

  function compute() {
    if (override) return override;
    if (!base) return null;
    var suffix = variantSuffix();
    if (!suffix) return base;
    // A title that already ENDS in the option value would otherwise read
    // "Dumbbell Set 5-30lbs — 5-30lbs".
    //
    // Tested on the end, not anywhere in the string. A substring test looks
    // equivalent and is not: "Covered Stretch Tubing" contains "red", inside
    // "Cove-red", so selecting Red silently produced no suffix at all while
    // Blue worked fine.
    var b = base.toLowerCase().replace(/[\s—\-–]+$/, '');
    var s = suffix.toLowerCase();
    if (b.slice(-s.length) === s) return base;
    return base + SEP + suffix;
  }

  function apply() {
    if (writing) return;
    desired = compute();
    if (!desired) return;
    writing = true;
    var hs = heads();
    for (var i = 0; i < hs.length; i++) {
      if (hs[i].textContent.trim() !== desired) hs[i].textContent = desired;
    }
    writing = false;
  }

  function init() {
    var h = document.querySelector('.product__title h1');
    if (!h) return;
    base = h.textContent.trim();
    apply();

    document.addEventListener('change', function (ev) {
      if (!(ev.target && ev.target.closest && ev.target.closest('variant-selects'))) return;
      // Let Dawn finish its own re-render before writing over the result.
      setTimeout(apply, 0);
    });

    document.addEventListener('goat:title-override', function (ev) {
      override = (ev.detail && ev.detail.title) || null;
      apply();
    });
    document.addEventListener('goat:title-release', function () {
      override = null;
      apply();
    });

    var container = document.querySelector('.product__info-container') || document.body;
    if (window.MutationObserver) {
      new MutationObserver(function () { apply(); }).observe(container, { childList: true, subtree: true, characterData: true });
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
